//@flow

import React, { Component } from 'react';
import { Button } from 'reactstrap';

import config from '../../config';

type Data = {
  email: string,
  accessToken: string,
  provider: string,
};
type State = { isSdkLoaded: boolean };
type Props = {
  submit: (data: Data) => void,
  loading: boolean,
  buttonText: string,
};
export default class GoogleLogin extends Component<Props, State> {
  static defaultProps = {
    buttonText: 'Sign up with Google',
  };

  state = { isSdkLoaded: false };

  signIn = async () => {
    try {
      const response = await window.gapi.auth2.getAuthInstance().signIn();

      this.props.submit(this.makeApiData(response));
    } catch (err) {
      console.log(err);
    }
  };

  makeApiData = response => ({
    email: response.w3.U3,
    accessToken: response.Zi.id_token,
    provider: 'google',
  });

  render() {
    return (
      <Button
        color="google-login"
        className={this.props.loading ? 'btn-login btn-loading btn-fw' : 'btn-fw'}
        onClick={this.signIn}
        disabled={!this.state.isSdkLoaded}
      >
        {this.props.buttonText}
      </Button>
    );
  }

  componentDidMount() {
    const isGoogleSdkLoaded = !!document.getElementById('google-login');

    if (isGoogleSdkLoaded) {
      this.setState({ isSdkLoaded: true });

      return;
    }

    this.loadGoogleSdk();
  }

  loadGoogleSdk = () => {
    ((d, s, id, cb) => {
      const element = d.getElementsByTagName(s)[0];
      const fjs = element;
      let js = element;
      js = d.createElement(s);
      js.id = id;
      js.src = '//apis.google.com/js/client:platform.js';
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = cb;
    })(document, 'script', 'google-login', () => {
      const params = { client_id: config.google };

      //initializing google api -- gapi
      window.gapi.load('auth2', () => {
        if (!window.gapi.auth2.getAuthInstance()) {
          window.gapi.auth2.init(params);
          this.setState({ isSdkLoaded: true });
        }
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/Login/GoogleLogin.jsx